import { useMemo } from 'react';
import format from '../utils/format';
export const initialize = ({ sort = 'score_desc', selectedFacets = [], term = null, base = '/', page = 0, } = {}) => ({
    sort,
    selectedFacets,
    term,
    base: base.endsWith('/') ? base : `${base}/`,
    page,
});
const equals = (s1, s2) => format(s1).href === format(s2).href;
export const useSearchState = (initialState, onChange) => {
    const state = useMemo(() => initialize(initialState), [initialState]);
    return useMemo(() => ({
        state,
        setState: (newState) => !equals(newState, state) && onChange(format(newState)),
    }), [onChange, state]);
};
//# sourceMappingURL=useSearchState.js.map